import { notification } from 'antd';


export const getApiMessage = (payload, fallback = 'Something went wrong. Please try again.') => {
  if (!payload) return fallback;
  return (
    payload?.response?.data?.message ||
    payload?.response?.data?.api?.message ||
    payload?.response?.data?.error ||
    payload?.message ||
    payload?.api?.message ||
    payload?.error ||
    fallback
  );
};

// Toast the exact API error message.
export const toastApiError = (payload, fallback) =>
  notification.error({ message: getApiMessage(payload, fallback) });
